import { Box, Typography, Grid } from '@mui/material'
import { styled, keyframes } from '@mui/material/styles'
import { COLORS } from '../constants/colors'
import { TEXT } from '../constants/text'
import { useTier } from '../hooks/useTier'
import { TIERS } from '../constants/tiers'
import SignalFeed from '../components/signals/SignalFeed'
import TierGate from '../components/layout/TierGate'
import RugScoreCard from '../components/signals/RugScoreCard'
import WhaleAlert from '../components/signals/WhaleAlert'
import BossManSignal from '../components/signals/BossManSignal'
// Note: paths are correct — pages/ and components/ are siblings under frontend-v2/

// Placeholder demo data for whale & boss sections
const DEMO_WHALES = [
  { wallet: '7xKXtg2CW87d97TXJSDpbD5jBkheTqA83TZRuJosgAsU', symbol: 'BONK', amount: 4250, action: 'buy', timestamp: Date.now() },
  { wallet: '3nMFwZXwY1s1M5s8vYAHqd4wMNKnmvq6x8MN4BUvQHxo', symbol: 'WIF', amount: 1800, action: 'buy', timestamp: Date.now() - 60000 },
]

const DEMO_BOSS = {
  type: 'HIGH_CONVICTION',
  symbol: 'POPCAT',
  price: 0.000142,
  change: 34.5,
  rugScore: 12,
  wallet: '5ZWj7a1f8tWkjBESHKgrLmXshuXxqeY9SYcfbshpAqPG',
  conviction: 87,
  timestamp: Date.now(),
}

const DEMO_RUG = {
  score: 18,
  checks: {
    MINT_AUTH: true,
    FREEZE_AUTH: true,
    LP_BURNED: true,
    TOP10: false,
    METADATA: true,
    BUNDLE: true,
    DEPLOYER: true,
  },
}

export default function SignalsPage({ onUpgrade }) {
  return (
    <Box sx={{ py: 2 }}>
      <Typography variant="h5" sx={{ fontWeight: 800, mb: 3 }}>
        {TEXT.NAV.SIGNALS}
      </Typography>

      <Grid container spacing={3}>
        {/* Left: Rug score demo */}
        <Grid item xs={12} md={4}>
          <RugScoreCard score={DEMO_RUG.score} checks={DEMO_RUG.checks} symbol="POPCAT" />
        </Grid>

        {/* Right: Whale alerts + Boss Man */}
        <Grid item xs={12} md={8}>
          {/* Whale alerts — PRO gated */}
          <TierGate requiredTier={TIERS.PRO} onUpgrade={onUpgrade}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, mb: 3 }}>
              <Typography variant="subtitle2" sx={{ color: COLORS.blue.primary }}>
                🐋 Recent Whale Activity
              </Typography>
              {DEMO_WHALES.map((w, i) => (
                <WhaleAlert key={i} {...w} />
              ))}
            </Box>
          </TierGate>

          {/* Boss Man signal — ELITE gated */}
          <TierGate requiredTier={TIERS.ELITE} onUpgrade={onUpgrade}>
            <Box>
              <Typography variant="subtitle2" sx={{ color: COLORS.gold.primary, mb: 1 }}>
                👑 Boss Man Signal
              </Typography>
              <BossManSignal signal={DEMO_BOSS} />
            </Box>
          </TierGate>
        </Grid>
      </Grid>
    </Box>
  )
}
